<template>
  <Loader v-if="isLoading" />
  <div v-else class="p-9 region-notice">

    <bim-text type=main bold class="mb-6">Укажите ваше местоположение</bim-text>

    <div v-show="slide === 0">
      <bim-text type=medium>Ваш регион {{ regionSuggest }}?</bim-text>

      <div class="mt-6 region-notice__button-wrapper">
        <bim-button
          label="Нет"
          @click="onAnswerNegative"
          class="mr-9"
          color=gray
        />

        <bim-button
          label="Да"
          @click="onAnswerPositive"
        />
      </div>
    </div>

    <div v-show="slide === 1">
      <bim-select
        placeholder="Выберите регион"
        :options="regionsList"
        v-model="region"
        valueName=id
        labelName=name
        listPosition=top
        width=100%
      />

      <bim-button
        class="region-notice__save-button mt-6"
        @click="saveRegion"
        :disabled="!region"
        label="Сохранить"
      />
    </div>
  </div>
</template>

<script>
import { getInformationAboutIP } from '@/components/core/dadata-mixin.js'

import bimButton from '@/components/form/bimButton/bimButton.vue'
import bimSelect from '@/components/form/bimSelect/bimSelect.vue'
import bimText from '@/components/text/bimText/bimText.vue'

import Loader from '@/components/core/loader'

export default {
  name: 'NoticeRegion',
  components: {
    bimButton,
    bimSelect,
    bimText,
    Loader
  },
  props: {
    apiHost: String
  },
  data: () => ({
    slide: 0,
    region: '',
    regionsList: [],
    isLoading: false,
    regionSuggest: ''
  }),
  async mounted () {
    this.isLoading = true
    try {
      const info = await getInformationAboutIP()
      this.regionSuggest = info.location.data.region

      this.regionsList = await this.fetchRegions()
      this.region = this.regionsList.find(region => region.name === this.regionSuggest).id
    } catch (e) {
      this.slide++
    }
    this.isLoading = false
  },
  methods: {
    onAnswerNegative () {
      this.slide++
    },

    async fetchRegions () {
      const resp = await fetch(`${this.apiHost}/dictionary/federalSubjects`, { headers: { Accept: 'application/json' } })
      const result = resp.ok ? await resp.json() : []

      return result.sort((a, b) => {
        const nameA = a.name.toUpperCase()
        const nameB = b.name.toUpperCase()

        if (nameA < nameB) return -1
        if (nameA > nameB) return 1

        return 0
      })
    },

    onAnswerPositive () {
      this.emitSave(this.region)
    },

    saveRegion () {
      this.emitSave(this.region)
    },

    emitSave (location) {
      this.isLoading = true
      this.$emit('save', {
        type: 'user',
        payload: { location },
        onFinish: () => {
          this.isLoading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.region-notice {
  position: relative;

  .region-notice__button-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .region-notice__save-button {
    display: block;
    margin-left: auto;
  }
}
</style>
